<lyceo-content [background]="true">
  <lyceo-single-card-layout *transloco="let t; scope: 'not-found'">
    <h3 class="mb-3">{{ t('notFound.title') }}</h3>
    <p class="mb-3">{{ t('notFound.description') }}</p>
    @if (isAuthenticated()) {
      <button lyceoButton [block]="true" (click)="home()" data-testid="button">
        {{ t('notFound.button') }}
      </button>
    }
  </lyceo-single-card-layout>
</lyceo-content>
